import React from "react";

type SearchBarProps = {
  placeholder?: string;
  onSearch?: (value: string) => void;
};

const SearchBar: React.FC<SearchBarProps> = ({
  placeholder = "job title, keywords or company",
  onSearch,
}) => {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const input = form.elements.namedItem("search") as HTMLInputElement | null;

    if (input && onSearch) {
      onSearch(input.value);
    }
  };

  return (
    <>
      <style>
        {`
          .search-wrapper {
            width: 50%;
            margin: 0 auto;
          }

          @media (max-width: 768px) {
            .search-wrapper {
              width: 100%;
              padding: 0 1rem;
            }
          }
            
          .search-box {
            border: 1px solid #ced4da;
            background-color: #fff;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
            position: relative; /* ⬅ for icon */
          }

          .search-box:focus-within {
            border-color: #10058c;
            box-shadow: 0 0 0 0.2rem rgba(16, 5, 140, 0.25);
          }

          .search-box input {
            outline: none;
            box-shadow: none;
            padding: 0.9rem 1.5rem 0.9rem 3rem; /* ⬅ space for icon */
            font-size: 1rem;
          }

          .search-icon {
            position: absolute;
            left: 1.25rem;
            top: 50%;
            transform: translateY(-50%);
            color: #6c757d !important;
            z-index: 3;
            pointer-events: none;
            font-size: 1.1rem;
          }

          .search-box button {
            padding: 0.9rem 1.75rem;
            font-size: 1rem;
          }

          .btn-search {
            background-color: #10058c;
            border-color: #10058c;
            color: #fff;
          }

          .btn-search:hover,
          .btn-search:focus {
            background-color: #0d0475;
            border-color: #0d0475;
            color: #fff;
          }

          .btn-search:active {
            background-color: #0a035e;
            border-color: #0a035e;
          }

          .border-search {
            border: 2px solid #10058c !important;
          }
        `}
      </style>

      <div className="search-wrapper">
        <form role="search" onSubmit={handleSubmit}>
          <div className="input-group rounded-pill overflow-hidden shadow-sm search-box border-search">
            <i className="bi bi-search search-icon" />
            <input
              name="search"
              type="search"
              className="form-control border-0"
              placeholder={placeholder}
              aria-label="Search"
            />
            <button className="btn btn-search" type="submit">
              Find a job
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default SearchBar;
